import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cfa2f91"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "container-1" }
const _hoisted_3 = { class: "autocomplete-bar" }
const _hoisted_4 = {
  key: 0,
  id: "autocomplete-results",
  class: "autocomplete-results"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Alles", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "LEI", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Namen", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Juristischer Sitz", -1))
const _hoisted_10 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container-2" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "radio",
    name: "radio",
    value: "global",
    checked: ""
  }),
  /*#__PURE__*/_createElementVNode("label", null, "Global"),
  /*#__PURE__*/_createElementVNode("input", {
    type: "radio",
    name: "radio",
    value: "wm"
  }),
  /*#__PURE__*/_createElementVNode("label", null, "WM Datenservice")
], -1))
const _hoisted_12 = { class: "container-3" }
const _hoisted_13 = { style: {"margin-right":"2em"} }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Entitäten ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Vergabestellen "),
  /*#__PURE__*/_createElementVNode("b", null, "39")
], -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" An dieser Stelle können Sie den gesamten LEI-Datenbestand von WM Datenservice durchsuchen. Verwenden Sie als Suchbegriff einen LEI, Namen oder den juristischen Sitz (Straße, Postleitzahl, Stadt) einer Entität. Die Verwendung unseres LEI-Registers unterliegt Nutzungsbedingungen, die Sie hier einsehen können. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_search_result = _resolveComponent("search-result")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_base_input, {
            placeholder: "LEI, Namen oder den juristischen Sitz eingeben",
            modelValue: _ctx.input.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input.value) = $event)),
            onInput: _ctx.searchLei,
            onKeyup: _withKeys(_ctx.searchResult, ["enter"])
          }, null, 8, ["modelValue", "onInput", "onKeyup"]),
          (_ctx.isOpen)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: result,
                    class: "autocomplete-result",
                    onClick: ($event: any) => (_ctx.updateSearch(result))
                  }, _toDisplayString(result.name), 9, _hoisted_5))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.option) = $event))
        }, _hoisted_10, 512), [
          [_vModelSelect, _ctx.option]
        ]),
        _createVNode(_component_base_button, {
          onClick: _ctx.searchResult,
          title: 'LEI SUCHEN',
          class: "searchButton"
        }, null, 8, ["onClick"])
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", null, [
          _createElementVNode("span", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("b", null, _toDisplayString(_ctx.dataSet), 1)
          ]),
          _hoisted_15
        ]),
        _hoisted_16
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_search_result, { searchActive: _ctx.searchActive }, null, 8, ["searchActive"])
    ])
  ], 64))
}